export enum KeyboardEventKey {
    Backspace = "Backspace",
    Delete = "Delete",
    Escape = "Escape",
}
